export enum ObservationType {
  Points,
  Image
}

export enum LocalObservationType {
  None,
  Scene,
  Aerial
}